import Piano from './piano';

function getKeyCodeFromEvent (event) {
  let returnValue = event.keyCode;

  returnValue = ('which' in event) ? event.which : returnValue;
  // A returnValue = ('key' in event) ? event.key : returnValue;

  return returnValue;
}

function getMidiFromKeyCode (keyCode) {
  const keyCodes = [
    90,
    83,
    88,
    68,
    67,
    86,
    71,
    66,
    72,
    78,
    74,
    77,
    81,
    50,
    87,
    51,
    69,
    82,
    53,
    84,
    54,
    89,
    55,
    85,
    73,
    57,
    79,
    48,
    80
  ];

  // 48 is base midi number, C4
  const index = 48 + keyCodes.indexOf(keyCode);

  return keyCodes.includes(keyCode) ? index : undefined;
}

const ComputerKeyboard = {
  getMidiFromEvent (event) {
    return this.getMidiFromKeyCode(this.getKeyCodeFromEvent(event));
  },

  getKeyCodeFromEvent,
  getMidiFromKeyCode,

  onKeyDown (event) {
    if (event.defaultPrevented) {
      return;
    }

    const keyCode = getKeyCodeFromEvent(event);
    const midiNumber = getMidiFromKeyCode(keyCode);

    if (!midiNumber) {
      return;
    }

    Piano.startNote(midiNumber);

    event.preventDefault();
  },

  onKeyUp (event) {
    if (event.defaultPrevented) {
      return;
    }

    const keyCode = getKeyCodeFromEvent(event);
    const midiNumber = getMidiFromKeyCode(keyCode);

    if (!midiNumber) {
      return;
    }

    Piano.stopNote(midiNumber);

    event.preventDefault();
  },

  init () {
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('keyup', this.onKeyUp);
  }
};

export default ComputerKeyboard;



// WEBPACK FOOTER //
// ./src/components/computer-keyboard.js